import styles from "./basic-spinner.module.css";

export default function BasicSpinner() {
  return <div className={styles["loader"]} />;
}
